import NotificationSettingsPage from "./pages/NotificationSettingsPage";

import { ROUTES } from "@/constants/routes";
import type { RouteConfig } from "@/types/route-types";

export const notificationSettingsRoute: RouteConfig = {
  path: `${ROUTES.notifications}/${ROUTES.settings}`,
  element: NotificationSettingsPage,
};
